import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import 'font-awesome/css/font-awesome.min.css';
import store from '_helpers/store';
import { session } from '_helpers';
import { LoggingProvider } from 'logging/CrLogger';
import App from './App';
import 'scss/style.css';

render(
  // Logging levels removed. This doesn't seem to be doing anything other than cloging the browser console
  // in development environment. Need to re-visit this in future.
  <LoggingProvider loggingMethods={[]}>
    <Provider store={store}>
      <OidcProvider store={store} userManager={session.userManager}>
        <App />
      </OidcProvider>
    </Provider>
  </LoggingProvider>,
  document.getElementById('app')
);
